import { CommunityPost as BaseCommunityPost } from '@factorialco/f0-react/dist/experimental'

const Skeleton = ({ numberOfItems = 3 }: { numberOfItems?: number }) =>
  new Array(numberOfItems)
    .fill(null)
    .map((_, index) => <BaseCommunityPost.Skeleton key={index} withEvent={index % 2 === 0} />)

export default Skeleton
